import React, { useState } from 'react';
import _ from 'lodash';

import { Row, Col } from 'antd';

import { ISortbar, ISortbarItem } from '../../../../../../common/models/Sortbar';

import './bv-customers-toolbar.scss';

import CommandOrderName from './components/CommandOrderName/command-order-name';
import CommandOrderSap from './components/CommandOrderSap/command-order-sap';

interface IBVCustomersSortbar {
    items?: ISortbarItem[]
    defaultSorting: ISortbar;
}

const BVCustomersSortbar: React.FunctionComponent<IBVCustomersSortbar> = ({ defaultSorting, items }) => {
    const [sorting, setStorting] = useState<ISortbar>(defaultSorting);

    const _handleIconByType = (sortCommand: ISortbarItem) => {
        let commandProps = {
            sorting: sorting,
            action: () => {
                if (!sortCommand.action) {
                    return;
                }

                let commandAction: 'asc' | 'desc' = 'asc';
                if (sorting.type === sortCommand.type) {
                    commandAction = sorting.sorting === 'asc' ? 'desc' : 'asc';
                }

                sortCommand.action(commandAction);

                setStorting({
                    sorting: commandAction,
                    type: sortCommand.type
                });
            }
        }

        switch (sortCommand.type) {
            case 'no-sort-draft': {
                return (
                    <div className='command'>
                        <span className="command-label italic">
                            Draft
                        </span>
                    </div>
                );
            }
            case 'sort-name': {
                return (
                    <CommandOrderName type={'sort-name'} {...commandProps} />
                );
            }
            case 'sort-sap': {
                return (
                    <CommandOrderSap type={'sort-sap'} {...commandProps} />
                );
            }
            default: {
                return (
                    <span className="bv-customers-toolbar-separator"></span>
                );
            }
        }
    }

    return (
        <div className="bv-customers-toolbar-container">
            <Row gutter={[16, 0]} justify={'end'}>
                {_.map(items, (dataItem, dataIndex) => (
                    <Col key={dataIndex} span={dataItem.colspan}>
                        {_handleIconByType(dataItem)}
                    </Col>
                ))}
            </Row>
        </div>
    );
}

export default BVCustomersSortbar;